"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_LOCALES = exports.DEFAULT_LOCALE = exports.getBundle = exports.tk = void 0;
var tk_js_1 = require("./tk.js");
Object.defineProperty(exports, "tk", { enumerable: true, get: function () { return tk_js_1.tk; } });
Object.defineProperty(exports, "getBundle", { enumerable: true, get: function () { return tk_js_1.getBundle; } });
var types_js_1 = require("./types.js");
Object.defineProperty(exports, "DEFAULT_LOCALE", { enumerable: true, get: function () { return types_js_1.DEFAULT_LOCALE; } });
Object.defineProperty(exports, "SUPPORTED_LOCALES", { enumerable: true, get: function () { return types_js_1.SUPPORTED_LOCALES; } });
//# sourceMappingURL=index.js.map